import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root'
})
export class LiveVideoService {
  constructor(private apiService: ApiService) { }

  startLiveVideo(type: any){
    return this.apiService.post(`/live/video/start?type=${type}`);
  }

  stopLiveVideo(id: string){
    return this.apiService.put(`/live/video/stop/${id}`);
  }

  getLiveVideos(){
    return this.apiService.get(`/live/video/list`);
  }

   getLiveVideo(userId: string){
    return this.apiService.get(`/live/video/detail/${userId}`);
  }

  stopLiveVideoByAdmin(id: any){
    return this.apiService.put(`/live/admin/video/stop/${id}`);
  }
}